

















































import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseDialog, Button, Input, SvgIcon } from "@brankas/web-ui";
import { UserListItem } from "@/types";

@Component({
  components: {
    BaseDialog,
    Button,
    Input,
    SvgIcon,
  },
})
export default class DeactivateUserDialog extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) isLastActiveUser!: boolean;
  @Prop({ type: Object, default: () => ({}) })
  selectedUser!: UserListItem;

  onCancel() {
    this.$emit("cancel");
  }

  onConfirm() {
    this.$emit("confirm");
  }
}
